module.exports = __webpack_public_path__ + "assets/img/benditong_img.9b6d6a65.png";